import {createSlice} from '@reduxjs/toolkit';
//types
import {IUserDonationReducer} from '../../utils/types';
//actions
import {getDonationListByEvent} from './actions';
//operations
import {getDonationListOperation, pendingOperation, rejectedOperation} from './operations';

export const initialState: IUserDonationReducer = {
	totalDonationsAmount: 0,
	donations: [],
	isLoading: false,
};

const userDonationStore = createSlice({
	name: 'userDonations',
	initialState,
	reducers: {},
	extraReducers: (builder) => {
		builder.addCase(getDonationListByEvent.pending, pendingOperation);
		builder.addCase(getDonationListByEvent.fulfilled, getDonationListOperation);
		builder.addCase(getDonationListByEvent.rejected, rejectedOperation);
	},
});

export default userDonationStore.reducer;
